import React from 'react';

export const ImageIcon = (props) => {
  return (
    <svg fill='currentColor' viewBox='0 0 14 10' height='1em' width='1em' {...props}>
      <g id='icon/type/image' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='bx:bxs-image' transform='translate(-1.000000, -3.330322)'>
          <rect id='ViewBox' x='0.5' y='0.884565217' width='15' height='15'></rect>
          <path
            d='M12.999375,3.38456522 L2.999375,3.38456522 C2.31,3.38456522 1.749375,3.94519022 1.749375,4.63456522 L1.749375,12.1345652 C1.749375,12.8239402 2.31,13.3845652 2.999375,13.3845652 L12.999375,13.3845652 C13.68875,13.3845652 14.249375,12.8239402 14.249375,12.1345652 L14.249375,4.63456522 C14.249375,3.94519022 13.68875,3.38456522 12.999375,3.38456522 Z M4.561875,5.25956522 C5.07964195,5.25956522 5.499375,5.67929826 5.499375,6.19706522 C5.499375,6.71483217 5.07964195,7.13456522 4.561875,7.13456522 C4.04410805,7.13456522 3.624375,6.71483217 3.624375,6.19706522 C3.624375,5.67929826 4.04410805,5.25956522 4.561875,5.25956522 L4.561875,5.25956522 Z M7.999375,11.5095652 L3.624375,11.5095652 L6.124375,8.38456522 L7.061875,9.63456522 L8.936875,7.13456522 L12.374375,11.5095652 L7.999375,11.5095652 Z'
            id='Shape'
            fill='currentColor'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </svg>
  );
};
